import React, { createClass, PropTypes } from 'react';
import getClassNames from 'classnames';

const SectionHeading = props => {
  const classes = getClassNames('tc-section-heading', props.className);

  const subtitle = props.subtitle ? (
    <h2 className="tc-section-heading-subtitle">
      {props.subtitle}
    </h2>
  ) : null;

  return (
    <div className={classes} style={props.style}>
      <h1 className="tc-section-heading-title">{props.title}</h1>
      <hr className="tc-section-heading-underline" />
      {subtitle}
    </div>
  );
};


SectionHeading.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.any,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default SectionHeading;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/section-heading.jsx